/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from "react";
import Model from "@tripian/model";
import {
  PreLoading,
  UserCompanions,
  Notification,
  CompanionModal,
} from "@tripian/react";
import { TRAVEL_COMPANIONS } from "../../constants/ROUTER_PATH_TITLE";
import useCompanionQuestions from "../../hooks/useQuestionCompanion";
import useCompanion from "../../hooks/useCompanion";
import AppNav from "../../App/AppNav/AppNav";
import useTranslate from "../../hooks/useTranslate";
import classes from "./TravelCompanions.module.scss";

enum CompanionModalMode {
  CREATE = "create",
  EDIT = "edit",
}

const TravelCompanions = () => {
  const [showWarningMessage, setShowWarningMessage] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCompanion, setSelectedCompanion] =
    useState<Model.Companion | null>(null);

  const { questionsCompanion, loadingQuestionsCompanion } =
    useCompanionQuestions();
  const {
    loadingCompanions,
    companionsFetch,
    companions,
    companionAdd,
    companionDelete,
    companionUpdate,
    loadingCompanionAdd,
    companionUpdateLoadingList,
    companionDeleteLoadingList,
  } = useCompanion();

  const { t } = useTranslate();

  document.title = TRAVEL_COMPANIONS.TITLE(t("user.travelCompanions.title"));

  useEffect(() => {
    companionsFetch();
  }, [companionsFetch]);

  const openAddModal = () => {
    setSelectedCompanion(null);
    setIsModalOpen(true);
  };

  const openEditModal = (companion: Model.Companion) => {
    setSelectedCompanion(companion);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCompanion(null);
  };

  const handleSubmitCompanion = (companion: Model.Companion) => {
    if (selectedCompanion) {
      companionUpdate(companion);
    } else {
      companionAdd(companion);
    }
    handleCloseModal();
  };

  if (loadingQuestionsCompanion || loadingCompanions) {
    return (
      <>
        <AppNav
          header={TRAVEL_COMPANIONS.HEADER?.(t("user.travelCompanions.title"))}
        />
        <PreLoading bgColor="rgba(238, 238, 238, 0.8)" />
      </>
    );
  }

  return (
    <div
      className="w-full"
      style={
        window.tconfig.IMAGE_PATHS.APP_BACKGROUND_IMG_URL
          ? {
              background: `url(${window.tconfig.IMAGE_PATHS.APP_BACKGROUND_IMG_URL})`,
            }
          : {}
      }
    >
      <AppNav
        header={TRAVEL_COMPANIONS.HEADER?.(t("user.travelCompanions.title"))}
      />

      <div className="container pt8">
        <div className="row">
          <div className={classes.travelCompanionsFormWrapper}>
            {loadingCompanionAdd && (
              <div className="flex items-center justify-center min-h-screen">
                <PreLoading />
              </div>
            )}

            <UserCompanions
              companions={companions || []}
              companionLoadingList={companionUpdateLoadingList.concat(
                companionDeleteLoadingList
              )}
              deleteCompanion={companionDelete}
              editCompanion={companionUpdate}
              addCompanion={companionAdd}
              showWarningMessage={setShowWarningMessage}
              onEditClick={openEditModal}
              onAddClick={openAddModal}
              t={t}
            />

            <CompanionModal
              isOpen={isModalOpen}
              onClose={handleCloseModal}
              onSubmit={handleSubmitCompanion}
              initialData={selectedCompanion}
              mode={
                selectedCompanion
                  ? CompanionModalMode.EDIT
                  : CompanionModalMode.CREATE
              }
              questions={questionsCompanion || []}
              t={t}
            />
          </div>
        </div>
      </div>

      {showWarningMessage && (
        <Notification
          type="warning"
          positionX="center"
          positionY="top"
          title={t("notification.changeCompanionWarning.title")}
          message={t("notification.changeCompanionWarning.message")}
          onClose={() => setShowWarningMessage(false)}
          closeMs={3500}
        />
      )}
    </div>
  );
};

export default TravelCompanions;
